import { useContext } from "react";
import { ConfigurationContext } from "../context/ConfigurationContext";

export function useConfiguration() {
  const value = useContext(ConfigurationContext);
  if (!value) {
    throw new Error("useConfiguration must be used within ConfigurationProvider");
  }
  return value;
}
